import {EntityService} from '../../../service/EntityService';

export class HelpActionService extends EntityService {

  static entity = 'app/help-action';
  static typeAction = [
    {value: 'Invoice', label: 'Hóa đơn không mã'},
    {value: 'InvoiceCode', label: 'Hóa đơn có mã'},
    {value: 'InvoiceCash', label: 'Hóa đơn có mã từ máy tính tiền'},
    {value: 'WrongInvoice', label: 'Thông báo sai sót'},
    {value: 'WrongInvoiceCash', label: 'Thông báo sai sót <Máy tính tiền>'},
    {value: 'Declare', label: 'Tờ khai'},
  ];
}
